<template>

  <div :class="classObj" class="app-wrapper">

    <div

      v-if="device === 'mobile' && sidebar.opened"

      class="drawer-bg"

      @click="handleClickOutside"

    />

    <sidebar v-if="!($route.meta && $route.meta.hideSidebar)" class="sidebar-container" />

    <div class="main-container">

      <div :class="{ 'fixed-header': fixedHeader }">

        <navbar v-if="!($route.meta && ($route.meta.hideNavbar || $route.meta.hideTagsView))" />

      </div>

      <app-main />

    </div>

  </div>

</template>

<script>

import { Navbar, Sidebar, AppMain } from './components'

import ResizeMixin from './mixin/ResizeHandler'

import routes from '@/router'

export default {

  name: 'Layout',

  components: {

    Navbar,

    Sidebar,

    AppMain

  },

  mixins: [ResizeMixin],

  data() {
    return {

    }
  },

  computed: {

    sidebar() {
      return this.$store.state.app.sidebar
    },

    device() {
      return this.$store.state.app.device
    },

    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },

    classObj() {
      const routeHideSidebar = !!(this.$route.meta && this.$route.meta.hideSidebar)

      const hideSidebar = routeHideSidebar || !this.sidebar.opened

      return {

        hideSidebar: hideSidebar,

        openSidebar: !routeHideSidebar && this.sidebar.opened,

        withoutAnimation: this.sidebar.withoutAnimation,

        mobile: this.device === 'mobile',

        routeHideSidebar: routeHideSidebar

      }
    }

  },

  created() {
    this.menuList = routes.options.routes

    this.roles = window.localStorage.getItem('roles')

    console.log('Layout created - roles:', this.roles)

    console.log('Layout created - menuList:', this.menuList)

    // 如果没有角色信息，设置默认值或跳过权限检查

    if (!this.roles) {
      console.warn('No user roles found in localStorage, setting default role for testing')

      // 临时设置一个默认角色用于测试

      this.roles = 'student'

      window.localStorage.setItem('roles', 'student')
    }

    this.menuList.forEach((element) => {
      console.log('Processing element:', element)

      // 检查是否有children且children不为空

      if (element.children && element.children.length > 0) {
        // 检查第一个子元素是否有meta和roles

        const firstChild = element.children[0]

        console.log('First child:', firstChild)

        if (firstChild && firstChild.meta && firstChild.meta.roles) {
          const roleKey = localStorage.getItem('roles')

          let isVisible = false

          // 遍历所有子元素检查角色权限

          element.children.forEach((item) => {
            if (item.meta && item.meta.roles) {
              item.meta.roles.forEach((role) => {
                if (role.startsWith(roleKey)) {
                  isVisible = true
                }
              })
            }
          })

          // 设置所有子元素的可见性

          element.children.forEach((item) => {
            if (item.meta) {
              item.meta.visible = isVisible
            }
          })
        }
      }
    })
  },

  methods: {

    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }

  }

}

</script>

<style lang="scss" scoped>

@use "~@/styles/mixin.scss" as mixins;

@use "~@/styles/variables.scss" as vars;

.app-wrapper {

  @include mixins.clearfix;

  position: relative;

  height: 100%;

  width: 100%;

  &.mobile.openSidebar {

    position: fixed;

    top: 0;

  }

}

.drawer-bg {

  background: #000;

  opacity: 0.3;

  width: 100%;

  top: 0;

  height: 100%;

  position: absolute;

  z-index: 999;

}

.fixed-header {

  position: fixed;

  top: 0;

  right: 0;

  z-index: 9;

  width: calc(100% - #{vars.$sideBarWidth});

  transition: width 0.28s;

}

.hideSidebar .fixed-header {

  width: calc(100% - 54px);

}

.mobile .fixed-header {

  width: 100%;

}

.routeHideSidebar .fixed-header {

  width: 100%;

}

.routeHideSidebar .main-container {

  margin-left: 0 !important;

}

</style>
